import React, { useState, useEffect, useRef } from "react";

const MultiplyBy11Game = () => {
  const [currentNumber, setCurrentNumber] = useState(null);
  const [correctAnswer, setCorrectAnswer] = useState(null);
  const [userInput, setUserInput] = useState("");
  const [feedback, setFeedback] = useState("");
  const [showRetry, setShowRetry] = useState(false);
  const [steps, setSteps] = useState([]);
  const inputRef = useRef();

  useEffect(() => {
    loadNewQuestion();
  }, []);

  const generateNumber = () => Math.floor(Math.random() * 90) + 10;

  const multiplyBy11Logic = (numStr) => {
    const d1 = parseInt(numStr[0], 10);
    const d2 = parseInt(numStr[1], 10);
    const sum = d1 + d2;
    if (sum < 10) return `${d1}${sum}${d2}`;
    else {
      const carry = 1;
      const mid = sum - 10;
      const newFirst = d1 + carry;
      return `${newFirst}${mid}${d2}`;
    }
  };

  const loadNewQuestion = () => {
    const num = generateNumber();
    setCurrentNumber(num);
    setCorrectAnswer(multiplyBy11Logic(num.toString()));
    setUserInput("");
    setFeedback("");
    setShowRetry(false);
    setSteps([]);
    inputRef.current?.focus();
  };

  const handleCheck = () => {
    if (!userInput.trim() || isNaN(userInput)) {
      setFeedback("Please enter a number!");
      return;
    }

    if (userInput === correctAnswer) {
      setFeedback("🎉 Awesome! You got it right! 🎉");
      setSteps([`Great job! You correctly multiplied ${currentNumber} × 11 = ${correctAnswer}`]);
    } else {
      setFeedback("Oops! Let me show you how to solve it.");
      showExplanation(currentNumber.toString());
    }

    setShowRetry(true);
  };

  const showExplanation = (numStr) => {
    const d1 = parseInt(numStr[0], 10);
    const d2 = parseInt(numStr[1], 10);
    const sum = d1 + d2;
    const explanationSteps = [
      `Starting digits: ${d1} and ${d2}`,
      `Add them: ${d1} + ${d2} = ${sum}`
    ];

    if (sum < 10) {
      explanationSteps.push(`No carry needed. Answer: ${d1}${sum}${d2}`);
    } else {
      const carry = 1;
      const mid = sum - 10;
      const newFirst = d1 + carry;
      explanationSteps.push(
        `Carry over 1. Add carry to first digit: ${d1} + 1 = ${newFirst}`,
        `Answer: ${newFirst}${mid}${d2}`
      );
    }

    setSteps(explanationSteps);
  };

  return (
    <div style={{ fontFamily: "'Baloo 2', cursive", textAlign: "center", background: "#fff8e7", padding: "20px", color: "#4b3b2b" }}>
      <h1 style={{ color: "#f76c6c", fontSize: "2.8em", textShadow: "1px 1px 0 #fff" }}>
        Multiply Two-Digit Numbers by 11!
      </h1>
      <p style={{ fontSize: "1.2em" }}>Enter your answer after multiplying the number by 11.</p>
      <div style={{ fontSize: "3.5em", letterSpacing: "10px", fontWeight: "900" }}>
        {currentNumber} × 11 = ?
      </div>
      <input
        type="number"
        ref={inputRef}
        value={userInput}
        onChange={(e) => setUserInput(e.target.value)}
        placeholder="Your answer"
        style={{
          fontSize: "2.5em",
          width: "250px",
          padding: "10px",
          borderRadius: "12px",
          border: "3px solid #f76c6c",
          textAlign: "center",
          fontWeight: "700",
          marginTop: "20px",
          outline: "none"
        }}
        onKeyDown={(e) => e.key === "Enter" && handleCheck()}
      />
      <br />
      <button
        onClick={handleCheck}
        style={{
          marginTop: "25px",
          background: "#f76c6c",
          color: "white",
          border: "none",
          borderRadius: "14px",
          padding: "15px 40px",
          fontSize: "1.8em",
          fontWeight: "900",
          cursor: "pointer",
          boxShadow: "0 4px #c54a4a"
        }}
      >
        Check Answer
      </button>
      <div style={{ marginTop: "30px", fontSize: "2em", minHeight: "80px", fontWeight: "900" }}>
        {feedback}
      </div>
      <div style={{
        marginTop: "35px",
        maxWidth: "400px",
        marginLeft: "auto",
        marginRight: "auto",
        textAlign: "left",
        background: "#fef5e7",
        borderRadius: "18px",
        padding: "20px 25px",
        boxShadow: "0 0 12px #f76c6c33",
        fontSize: "1.3em",
        color: "#7f5a47"
      }}>
        {steps.map((step, i) => (
          <div key={i} style={{ marginBottom: "10px" }}>{step}</div>
        ))}
      </div>
      {showRetry && (
        <button
          onClick={loadNewQuestion}
          style={{
            marginTop: "25px",
            background: "#4caf50",
            color: "white",
            border: "none",
            borderRadius: "14px",
            padding: "15px 40px",
            fontSize: "1.8em",
            fontWeight: "900",
            cursor: "pointer",
            boxShadow: "0 4px #388e3c"
          }}
        >
          Try Another Number
        </button>
      )}
    </div>
  );
};

export default MultiplyBy11Game;
